















































































































































import { Component, Vue } from "vue-property-decorator";
import { MessageService } from "@/shared/services/message-service";
import { canales_entrada } from "@/shared/dtos/canales_entrada";
import canalesEntradaModule from "@/store/modules/canales_entrada-module";

@Component({
  name: "CanalesEntradaManager",
})
export default class CanalesEntradaManager extends Vue {
  public loading: boolean = false;
  public saving: boolean = false;
  public dialogOpen: boolean = false;
  public isEditMode: boolean = false;
  public searchText: string = "";
  public form: canales_entrada = new canales_entrada();

  public headers: any[] = [
    { text: "Codigo", value: "codigo", width: "180px" },
    { text: "Nombre", value: "nombre" },
    { text: "Agenda", value: "bloquea_agenda", width: "140px" },
    { text: "Estado", value: "activo", width: "120px" },
    { text: "Acciones", value: "actions", sortable: false, align: "center", width: "110px" },
  ];

  public mounted() {
    this.refresh();
  }

  public get rows(): canales_entrada[] {
    return canalesEntradaModule.canalesEntrada;
  }

  public get filteredRows(): canales_entrada[] {
    const search = (this.searchText || "").toLowerCase().trim();
    if (!search) {
      return this.rows;
    }

    return this.rows.filter((x) => {
      const value = (x.codigo + " " + x.nombre).toLowerCase();
      return value.indexOf(search) !== -1;
    });
  }

  public async refresh() {
    this.loading = true;
    try {
      await canalesEntradaModule.getCanalesEntrada();
    } catch (error) {
      MessageService.alert(
        "Error",
        "No se pudieron cargar los canales de entrada",
        MessageService.TypeError
      );
    } finally {
      this.loading = false;
    }
  }

  public openCreate() {
    this.isEditMode = false;
    this.form = new canales_entrada();
    this.form.bloquea_agenda = true;
    this.form.activo = true;
    this.dialogOpen = true;
  }

  public openEdit(item: canales_entrada) {
    this.isEditMode = true;
    this.form = new canales_entrada(item);
    this.dialogOpen = true;
  }

  public async save() {
    if (!this.form.codigo || !this.form.nombre) {
      MessageService.alert(
        "Validacion",
        "Codigo y nombre son obligatorios",
        MessageService.TypeWarning
      );
      return;
    }

    this.saving = true;
    try {
      this.form.codigo = (this.form.codigo || "").trim().toUpperCase();
      this.form.nombre = (this.form.nombre || "").trim();

      if (this.isEditMode) {
        await canalesEntradaModule.modificarCanalEntrada(this.form);
      } else {
        await canalesEntradaModule.guardarCanalEntrada(this.form);
      }

      MessageService.toast("Canal guardado correctamente");
      this.dialogOpen = false;
      await this.refresh();
    } catch (error) {
      MessageService.alert(
        "Error",
        "No se pudo guardar el canal de entrada",
        MessageService.TypeError
      );
    } finally {
      this.saving = false;
    }
  }

  public remove(item: canales_entrada) {
    MessageService.confirm(
      "Quieres eliminar este canal de entrada?",
      "Confirmacion",
      async (res: boolean) => {
        if (!res) return;
        try {
          await canalesEntradaModule.eliminarCanalEntrada(item);
          MessageService.toast("Canal eliminado correctamente");
          await this.refresh();
        } catch (error) {
          MessageService.alert(
            "Error",
            "No se pudo eliminar el canal",
            MessageService.TypeError
          );
        }
      }
    );
  }
}
